var utils = require('../../utils')
import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'stepup-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      stepups: '',
      searchShop: '',
      searchUser: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    async search (addSearch) {
      let data = {
        search_shop: this.searchShop,
        search_user: this.searchUser
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_STEPUP_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.stepups = this.stepups.concat(res.step_ups.data)
      } else {
        this.stepups = res.step_ups.data
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    goStepupNew: function () {
      this.$router.push({ path: '/stepup/new' })
    },
    goStepupEdit: function (stepupId) {
      this.$router.push({ path: '/stepup/' + stepupId + '/edit' })
    },
    goStepupDetail: function (stepupId) {
      this.$router.push({ path: '/stepup/' + stepupId })
    },
    stepupDelete: function (stepupId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('DELETE_STEPUP', {
          data: {
            id: stepupId
          }
        })
        .then(res => {
          this.search(false)
        })
        .catch(err => console.log(err))
      }
    },
    isBeforeNotificationStartDate (notificationStartDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')
      return !DayJs(notificationStartDate).isAfter(today)
    },
    isReleaseStatus (notificationStartDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(notificationStartDate)) {
        return '未公開'
      }
      if (DayJs(endDate).isBefore(today)) {
        return '公開完了'
      }
      return '公開中'
    },
    getColor: function (notificationStartDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(notificationStartDate)) {
        return 'color-blue'
      }
      if (DayJs(endDate).isBefore(today)) {
        return 'color-gray'
      }
      return 'color-orange'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stepup-list.js